export class SignaturePageError extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
  }
}

// The generic API wrapper redirects to /login on 401 and to /maintenance on 503:
// this public page needs the raw status instead (503 = documents still being prepared).
class SignaturePageRepository {
  public get(type: string, uuid: string, token: string): Promise<SignaturePageSignerInterface[]> {
    const url = `/api/yousign/generate-signature-procedure/${encodeURIComponent(type)}/${encodeURIComponent(uuid)}/${encodeURIComponent(token)}`;

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(async (response: Response) => {
        let body = { data: null, errors: null } as GaiaApiInterface;
        try {
          body = await response.json() as GaiaApiInterface;
        } catch {
          // A body that is not JSON is reported through the status below.
        }
        if (!response.ok) {
          throw new SignaturePageError(response.status, body.message || '');
        }

        return (body.data || []) as SignaturePageSignerInterface[];
      });
  }
}

export default new SignaturePageRepository();
